import { FormLabel } from '@/components/ui/form'
import { DetailButtons } from './DetailButtons'
import RutsTable from './RutsTable'
import { rutsAKey } from './constants'
import CreateModal from './CreateModal'

export function BasicDetail({
  processData,
  setProcessData,
  handleGetTemplate,
  enrichmentType,
  isViewMode,
}: {
  processData: FormProcessData
  setProcessData: React.Dispatch<React.SetStateAction<FormProcessData>>
  handleGetTemplate: () => void
  enrichmentType: number | undefined
  isViewMode: boolean
}) {
  return (
    <>
      <div className="flex flex-row items-center w-full">
        <div className="form-title-label pb-5 pt-5 min-w-[150px]">Carga de archivos</div>
        <div className="flex justify-start items-center w-full">
          <CreateModal
            processData={processData}
            enrichmentType={enrichmentType}
            setProcessData={setProcessData}
            handleGetTemplate={handleGetTemplate}
            isViewMode={isViewMode}
          />
        </div>
      </div>
      <div className="flex flex-row items-center w-full">
        <FormLabel className="form-label w-full">Detalle de carga</FormLabel>
        <div className="flex justify-end items-center w-full">
          <DetailButtons
            processData={processData}
            setProcessData={setProcessData}
            enrichmentType={enrichmentType}
            rutKey={rutsAKey}
            isViewMode={isViewMode}
          />
        </div>
      </div>
      <div className="h-full w-full overflow-y-auto">
        <RutsTable
          processData={processData}
          setProcessData={setProcessData}
          rutKey={rutsAKey}
          isViewMode={isViewMode}
        />
      </div>
    </>
  )
}
